import createUploadLink from 'apollo-upload-client/createUploadLink.mjs'

import config from 'src/config'

const uploadLink = createUploadLink({ uri: config.GATEWAY_URL })

export default uploadLink
